'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight } from '@phosphor-icons/react';
import { RESEARCH_CITATIONS } from '@/src/constants/Research';
import { sendAnalyticsData } from '@/src/utils/analytics';
export const ResearchBase = () => {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-3 flex justify-center"><span className="rounded-2xl bg-[#f2faff] px-4 py-2 text-[13px] font-medium text-[#527B94]">Evidence Base</span></div>;
    t1 = <h2 className="text-center text-2xl font-medium text-[#3D3E40] md:text-3xl">Grounded in 6 Peer-Reviewed Studies</h2>;
    t2 = <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] text-[#616366]">Every design decision in Ablespace maps directly to peer-reviewed, empirically validated research.</p>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-16 md:py-24"><div className="container mx-auto px-6 md:px-10 2xl:px-[10rem]">{t0}{t1}{t2}<div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2">{RESEARCH_CITATIONS.map(_temp)}</div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(citation) {
  return <div key={citation.id} className="flex flex-col rounded-2xl border border-[#EAF1FB] bg-white p-6"><div className="flex items-center justify-between gap-3"><span className="rounded-full bg-[#f2faff] px-3 py-1.5 text-xs font-medium text-[#527B94]">{citation.designDecision}</span><span className="text-xs font-semibold text-[#D0DDE9]">{String(citation.id).padStart(2, "0")}</span></div><h3 className="mt-4 text-base font-semibold leading-snug text-[#3D3E40]">{citation.title}</h3><p className="mt-3 line-clamp-3 text-[15px] leading-relaxed text-[#616366]">{citation.finding}</p><div className="mt-auto flex items-end justify-between gap-4 border-t border-[#EAF1FB] pt-4 mt-5"><p className="text-xs text-[#616366]">{citation.authors} · {citation.year}<br />{citation.sample}</p><a href={`https://doi.org/${citation.doi}`} target="_blank" rel="noopener noreferrer" onClick={() => sendAnalyticsData("RESEARCH_DOI_LINK_CLICKED", {
        doi: citation.doi
      })} className="flex shrink-0 items-center gap-1 text-sm font-medium text-[#318AE5] hover:underline">View Study<ArrowUpRight size={14} weight="bold" /></a></div></div>;
}